// extracted by mini-css-extract-plugin
module.exports = {"wrap":"LKhHO","body":"jdzcI","button":"oaL1v","primary":"ZbaT8","footer":"WNzSK","clearBtn":"WRYrs","applyBtn":"_2Euw7","arrowIcon":"_5W4Mo"};